import { useEffect, useState } from 'react';
import { OrganizationApi } from '../../../api';
import { BranchDto } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';

const useHttpGetBranchByIdOnMount = (branchId?: string) => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [branch, setBranch] = useState<BranchDto>();
    const [isBranchReady, setIsBranchReady] = useState<boolean>(false);

    const getBranchById = (branchId: string) => {
        const { exec, abort } = organizationApi.getBranchById({
            params: { branchId },
            onSuccess: res => {
                setBranch(res.body);
                setIsBranchReady(true);
            },
            onError: err => err,
        });
        exec();
        return abort;
    };

    useEffect(() => {
        if (branchId) getBranchById(branchId);
    }, [branchId]);

    return { branch, isBranchReady };
};

export default useHttpGetBranchByIdOnMount;
